import { getTelegramWebApp } from './telegram';

let currentHandler: (() => void) | null = null;

export type MainButtonConfig = {
  text: string;
  visible: boolean;
  active: boolean;
  onClick?: () => void;
};

export function applyMainButton(cfg: MainButtonConfig) {
  const tg = getTelegramWebApp();
  if (!tg) return;
  const mb = tg.MainButton;

  if (currentHandler) {
    mb.offClick(currentHandler);
    currentHandler = null;
  }

  if (!cfg.visible) {
    mb.hide();
    return;
  }
  mb.setText(cfg.text);
  if (cfg.active) mb.enable(); else mb.disable();
  if (cfg.onClick) {
    currentHandler = cfg.onClick;
    mb.onClick(currentHandler);
  }
  mb.show();
}

export function hideMainButton() {
  applyMainButton({ text: '', visible: false, active: false });
}
